define("settings/components/navigation-footer", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--page__sidebarFooter">
    <ul class="o--page__sidebarList cNA--list u--m__lr__0">
      <li class="cNA--list__item cNA--list__item--footer">
        <LinkToExternal
          @route="cluster.schedule.calendar"
          @model={{@slug}}
          class="cNA--nav__link"
        >
          {{svg-jar "calendar" class="o--icon--md o--icon--hl cNA--list__icon"}}
          <span class="cNA--list__label u--text--hl at--onboardingSkippedProfileConnect__calendarLink">
            {{t "header.navigation.back_dashboard"}}
          </span>
        </LinkToExternal>
      </li>
  
      <li class="cNA--list__item cNA--list__item--footer">
        <Shared::Ui::Button
          class="cNA--nav__link"
          @type="unstyled"
          {{on "click" (action @openChatbot "help")}}
        >
          {{svg-jar "help-solid" class="o--icon--md cNA--list__icon"}}
          <span class="cNA--list__label">
            {{t "header.about.support"}}
          </span>
        </Shared::Ui::Button>
      </li>
  
      <li
        class="cNA--list__item cNA--list__item--footer u--p__lr__sm u--clearfix"
      >
        <Shared::AppFooter
          @dropTarget="e--footer__toggle"
          @logout={{action @logout}}
        />
  
      </li>
    </ul>
  </section>
  
  */
  {
    "id": "hWDa0XxZ",
    "block": "[[[10,\"section\"],[14,0,\"o--page__sidebarFooter\"],[12],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"o--page__sidebarList cNA--list u--m__lr__0\"],[12],[1,\"\\n    \"],[10,\"li\"],[14,0,\"cNA--list__item cNA--list__item--footer\"],[12],[1,\"\\n      \"],[8,[39,0],[[24,0,\"cNA--nav__link\"]],[[\"@route\",\"@model\"],[\"cluster.schedule.calendar\",[30,1]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"calendar\"],[[\"class\"],[\"o--icon--md o--icon--hl cNA--list__icon\"]]]],[1,\"\\n        \"],[10,1],[14,0,\"cNA--list__label u--text--hl at--onboardingSkippedProfileConnect__calendarLink\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"header.navigation.back_dashboard\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"li\"],[14,0,\"cNA--list__item cNA--list__item--footer\"],[12],[1,\"\\n      \"],[8,[39,3],[[24,0,\"cNA--nav__link\"],[4,[38,4],[\"click\",[28,[37,5],[[30,0],[30,2],\"help\"],null]],null]],[[\"@type\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"help-solid\"],[[\"class\"],[\"o--icon--md cNA--list__icon\"]]]],[1,\"\\n        \"],[10,1],[14,0,\"cNA--list__label\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"header.about.support\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"li\"],[14,0,\"cNA--list__item cNA--list__item--footer u--p__lr__sm u--clearfix\"],[12],[1,\"\\n      \"],[8,[39,6],null,[[\"@dropTarget\",\"@logout\"],[\"e--footer__toggle\",[28,[37,5],[[30,0],[30,3]],null]]],null],[1,\"\\n\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@slug\",\"@openChatbot\",\"@logout\"],false,[\"link-to-external\",\"svg-jar\",\"t\",\"shared/ui/button\",\"on\",\"action\",\"shared/app-footer\"]]",
    "moduleName": "settings/components/navigation-footer.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});